export enum dialogueItemStatus {
  DEFALUT = 0, // 默认状态
  SOONSINK = 1, // 即将下沉
  SINK = 2, // 已下沉
}
